import { useQuery } from "@tanstack/react-query";
import { getCurrentGeneration } from "../../api/generations";
import { GenerationDto } from "../../types/traineesTypes";

/**
 * Hook that handles the current trainee generation api calls, uses react-query
 * @returns The current trainee generation and a boolean indicating if the current trainee generation is fetched
 */
const useCurrentTraineeGeneration = () => {
  // getCurrentTraineeGeneration query
  const { data: currentTraineeGenerationData, isFetched: isCurrentTraineeGenerationFetched } = useQuery({
    queryKey: ["currentTraineeGeneration"],
    queryFn: () => {
      return getCurrentGeneration();
    },
  });

  const currentTraineeGeneration: GenerationDto | null = currentTraineeGenerationData?.data || null;

  return {
    currentTraineeGeneration,
    isCurrentTraineeGenerationFetched,
  };
};

export default useCurrentTraineeGeneration;
